import clsx from 'clsx';
import { ComponentSize } from '../../../types';
import { Tooltip } from '../Tooltip';
import { AVATAR_SIZE_TO_WIDTH } from './Avatar.constants';
import { AvatarProps } from './Avatar.types';
import { stringToColor } from './Avatar.utils';

const Avatar = ({ imgSrc, label: labelProp, ring, size = ComponentSize.SMALL, showTooltip }: AvatarProps) => {
  // If the label is a number, we assume it's a count and parse it as a string with a plus sign.
  const isCount = typeof labelProp === 'number';
  const label = isCount ? `+${labelProp}` : labelProp;

  // Get background color based on the text input.
  const { bgColor, textColor } = stringToColor(label);

  const avatarSize = typeof size === 'number' ? size : AVATAR_SIZE_TO_WIDTH[size];

  const renderContent = () => {
    if (imgSrc) return <img src={imgSrc} />;
    return isCount ? label : label?.charAt(0).toUpperCase();
  };

  return (
    <Tooltip label={label} disabled={!showTooltip}>
      <div className={clsx('avatar placeholder rounded-full', ring && 'border-2 border-base-100')}>
        <div className={clsx('rounded-full', bgColor, textColor)} style={{ width: avatarSize, height: avatarSize }}>
          {renderContent()}
        </div>
      </div>
    </Tooltip>
  );
};

export default Avatar;
